export enum HistoryTypes {
  GrantedAutomatically = 'granted-automatically',
  CustomAward = 'custom-award',
  Withdraw = 'withdraw',
  GrantedByAdmin = 'granted-by-admin',
  Exchanged = 'exchanged',
}
